export function getText(addresses) {
  return `${addresses.length} ${
    addresses.length > 1 ? 'profiles' : 'profile'
  } with same address`
}
